import React, { useState, useEffect, createContext } from "react";
import useApi from "../hooks/useApi";
import useIdleLogout, {
    clearIdleSessionKeys,
    touchIdleActivity,
} from "../hooks/useIdleLogout";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const api = useApi();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = async () => {

        setLoading(true);

        try {

            const { data } = await api.get('/Painel/API/Auth/');

            if (data && Object.keys(data).length > 0) {

                setUser(data);

            }

        } catch (error) {

            console.log(error);
            setUser(null);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        checkAuth();

    }, [])

    const login = async (email, senha) => {

        setLoading(true);

        const formData = new FormData();
        formData.append('email', email);
        formData.append('senha', senha);

        try {

            await api.post('/Painel/API/Login/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            clearIdleSessionKeys();
            await checkAuth();
            touchIdleActivity();

        } catch (error) {

            throw error;

        } finally {

            setLoading(false);

        }

    }

    const logout = async () => {

        try {

            await api.post('/Painel/API/Auth/logout.php', {});
            clearIdleSessionKeys();
            setUser(null);
            window.location.href = "/login";

        } catch (error) {

            console.log(error);

        }

    }

    useIdleLogout(user, logout);

    const removeUser = () => {

        setUser(null)

    }

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, removeUser }}>
            {children}
        </AuthContext.Provider>
    );
};